import { useEffect, useState } from "react";
import { fetchDeductions } from "../Api/ViewDeductions";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { useAuth } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";

const ViewDeductions = () => {
  const [deductions, setDeductions] = useState([]);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const loadDeductions = async () => {
      try {
        const data = await fetchDeductions(user?.organisationId);
        setDeductions(data || []);
      } catch (error) {
        toast.error("🦄 Error Fetching Deductions");
      }
    };

    loadDeductions();
  }, [user]);

  return (
    <div className="main-content expand">
      <Container fluid className="list-container">
        <span className="list-title">View Deductions</span>

        {/* Back to Add Button */}
        <Button
          className="mb-3"
          variant="primary"
          onClick={() => navigate("/deductionMaster")}
        >
          + Add Deduction
        </Button>

        {deductions.length > 0 ? (
          <div className="table-wrapper">
            <div className="table-scroll-container">
              <Table bordered hover className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Deduction ID</th>
                    <th>Working Days ID</th>
                    <th>Resource ID</th>
                    <th>Payroll ID</th>
                    <th>Deduction Type</th>
                    <th>Deduction Amount</th>
                    <th>Created At</th>
                    <th>Created By</th>
                  </tr>
                </thead>

                <tbody>
                  {deductions.map((deduction, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{deduction.deductionId}</td>
                      <td>{deduction.workingDaysId}</td>
                      <td>{deduction.resourceId}</td>
                      <td>{deduction.payrollid}</td>
                      <td>{deduction.deductionType}</td>
                      <td>{deduction.deductionAmount}</td>
                      <td>
                        {moment(deduction.createdAt).format("L")} at{" "}
                        {moment(deduction.createdAt).format("LTS")}
                      </td>
                      <td>{deduction.createdBy}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        ) : (
          <p className="no-data">No deductions found.</p>
        )}
      </Container>
    </div>
  );
};

export default ViewDeductions;
